const parse = ( apiError ) => {
  switch ( apiError.data?.error ) {
    case 'invalid':
      return 'Whoops, looks like the user/password is incorrect.';
    case 'does-not-exist':
      return "Whoops, looks like you don't have an account yet.";
    case 'account-locked':
      return 'Whoops, your account is locked. Please wait 5 minutes or contact customer support to unlock your account.';
    case 'last-attempt-warning':
      return 'Whoops, you have one more login attempt before your account is locked.';
    default:
      return "Whoops! Something went wrong and we can't log you in at this moment. Please try again later.";
  }
};

export default {
  parse,
};
